import { tns, TinySliderInstance } from "tiny-slider";

/** @param {HTMLElement} tabsContainer */
export function manageTabs(tabsContainer) {
    const tabs = tabsContainer.querySelectorAll('.tab');
    const sectionLinkElm = tabsContainer.querySelector('.sideLinks .link');

    tabs.forEach(tab => tab.addEventListener('click', function(e){
        tabsContainer.querySelector('.active').classList.remove('active');
        e.target.classList.add('active');

        // Takes the link from the tab, and set it in the link "See all" element.
        const sectionLink = e.target.getAttribute('data-section-link');
        if(sectionLink){
            sectionLinkElm.setAttribute('href', sectionLink);
        }
    }));

    return tabs;
}

/**
 * 
 * @param {HTMLElement} sliderContainer The slider container element.
 * @param {Number} desktopItemsAmount The amount of slides visible in a Desktop screen
 * @returns {TinySliderInstance} An instance of this slider
 */
export function initSlider(sliderContainer, desktopItemsAmount = 5) {
    return tns({
        container: sliderContainer,
        items: 1,
        controls: true,
        controlsPosition: 'bottom',
        nav: false,
        responsive: {
            768: { items: 3 },
            1300: { items: desktopItemsAmount }
        }
    })
}